import { render, staticRenderFns } from "./IllustrationCashHandCroppedBottomLeft.svg?vue&type=template&id=c0124520&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports